var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCircleDownloadPdfGreyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 166.10001,
    width: 166.10001,
    viewBox: "0 0 166.1 166.10001",
    "data-name": "Capa 1",
    id: "Capa_1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs4"
  }, /*#__PURE__*/React.createElement("style", {
    id: "style2"
  }, ".cls-1{fill:#c72e26;}.cls-2,.cls-4{fill:#fff;}.cls-3{fill:#737373;}.cls-4{stroke:#1d1d1b;stroke-miterlimit:10;stroke-width:0.25px;}"))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-378.92,-39.75)",
    id: "Descarga"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Descarga-2"
  }, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#737373"
    },
    r: 83.050003,
    cy: 122.8,
    cx: 461.97,
    className: "cls-3",
    "data-name": "Elipse 6-2",
    id: "Elipse_6-2"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Grupo 125",
    id: "Grupo_125"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff"
    },
    d: "m 473.61,76.47 c 3.89,3.89 5.27,14.23 4.55,19.09 a 29.57,29.57 0 0 1 20.37,3.93 104.74,104.74 0 0 0 -24.92,-23.02 z m -18.53,40.37 c -0.3,-0.66 -1.17,-0.77 -1.94,-0.77 h -1.84 v 3.12 h 1.84 c 0.77,0 1.64,-0.1 1.94,-0.77 a 1.73,1.73 0 0 0 0,-1.58 z",
    className: "cls-2",
    id: "file-33"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff"
    },
    d: "m 470.92,103 c 0,0 5.05,-26.75 -11.2,-26.75 h -28.16 v 80.32 h 32.72 a 11.47,11.47 0 0 1 -0.08,-1.76 19.56,19.56 0 0 1 34.3,-13 V 113.06 C 498.52,101.62 480.92,100.53 470.92,103 Z m -13,16.14 a 2.91,2.91 0 0 1 -1.17,1.6 4.73,4.73 0 0 1 -3,0.92 h -2.52 v 4.29 h -3 v -12.31 h 5.55 a 3.93,3.93 0 0 1 4.12,2.53 4.36,4.36 0 0 1 0.1,2.94 z m 12.36,3.7 a 3.4,3.4 0 0 1 -0.75,1.35 6.27,6.27 0 0 1 -1.68,1.26 5.82,5.82 0 0 1 -2.53,0.51 H 460 v -12.31 h 5.38 a 5.49,5.49 0 0 1 4,1.51 7.16,7.16 0 0 1 0.94,7.65 z m 11.44,-6.56 H 476 v 2.36 h 5 v 2.44 h -5 v 4.87 h -3 v -12.3 h 8.74 z",
    className: "cls-2",
    "data-name": "Trazado 372",
    id: "Trazado_372"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff"
    },
    d: "m 468,120.29 a 2.84,2.84 0 0 1 -0.25,1.26 2.61,2.61 0 0 1 -0.93,1.35 h -0.08 a 2.89,2.89 0 0 1 -1.51,0.42 h -2.1 v -7.07 h 1.59 a 2.83,2.83 0 0 1 3.12,2.11 13.83,13.83 0 0 1 0.16,1.93 z",
    className: "cls-2",
    "data-name": "Trazado 373",
    id: "Trazado_373"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff"
    },
    d: "m 494.28,151.74 -4.2,4.81 -6.29,7.22 -6.29,-7.22 -4.26,-4.81 h 6.09 v -15 h 9 v 15 z",
    className: "cls-2",
    "data-name": "Trazado 374",
    id: "Trazado_374"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff"
    },
    d: "m 501.85,154.75 a 18.022736,18.022736 0 0 1 -36,1.81 10.93,10.93 0 0 1 -0.1,-1.81 18,18 0 0 1 8.65,-15.46 l 1.89,2.45 a 15,15 0 0 0 -7.52,13 5.28,5.28 0 0 0 0.2,1.81 14.88,14.88 0 0 0 14.81,13.2 15,15 0 0 0 15,-15 16,16 0 0 0 -0.31,-3 15.07,15.07 0 0 0 -7.16,-10 l 1.74,-2.46 a 18.27,18.27 0 0 1 5.41,5.06 17.77,17.77 0 0 1 3.39,10.4 z",
    className: "cls-2",
    "data-name": "Trazado 375",
    id: "Trazado_375"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleDownloadPdfGreyIcon);
export default __webpack_public_path__ + "static/media/circle-download-pdf-grey-icon.5262967dd4ae5e50d01d682839538e04.svg";
export { ForwardRef as ReactComponent };